import { Link } from 'react-router-dom';
import { getContact } from '@/lib/content';

export function Footer() {
  const contact = getContact();
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <span className="site-footer__mark">BED</span>
          <p className="caption">{contact.company} — Multidisciplinary interior design.</p>
        </div>

        <div className="site-footer__cols">
          <div>
            <p className="eyebrow">Studio</p>
            <p className="caption">
              {contact.address.street}<br />
              {contact.address.city}, {contact.address.region} {contact.address.postalCode}
            </p>
            {contact.hours?.byAppointment ? <p className="caption">By appointment</p> : null}
          </div>
          <div>
            <p className="eyebrow">Contact</p>
            <p className="caption">
              <a href={`mailto:${contact.email}`} className="text-link">{contact.email}</a><br />
              <a href={`tel:${contact.phone.replace(/[^+\d]/g, '')}`} className="text-link">{contact.phone}</a>
            </p>
          </div>
          <div>
            <p className="eyebrow">Browse</p>
            <ul className="site-footer__links">
              <li><Link to="/projects" className="text-link">Projects</Link></li>
              <li><Link to="/services" className="text-link">Services</Link></li>
              <li><Link to="/journal" className="text-link">Journal</Link></li>
              <li><Link to="/about" className="text-link">Studio</Link></li>
              <li><Link to="/contact" className="text-link">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow">Off-site</p>
            <ul className="site-footer__links">
              {contact.social.instagram ? (
                <li>
                  <a className="text-link" href={`https://instagram.com/${contact.social.instagram.replace(/^@/, '')}`} target="_blank" rel="noreferrer">
                    Instagram
                  </a>
                </li>
              ) : null}
              {contact.social.houzz ? (
                <li><a className="text-link" href={contact.social.houzz} target="_blank" rel="noreferrer">Houzz</a></li>
              ) : null}
            </ul>
          </div>
        </div>
      </div>
      <div className="container site-footer__base">
        <p className="caption">© {year} {contact.company}. All rights reserved.</p>
        <div className="site-footer__legal-links">
          <Link to="/privacy" className="text-link caption">Privacy</Link>
          <Link to="/terms" className="text-link caption">Terms</Link>
        </div>
      </div>
    </footer>
  );
}
